import { YieldList } from "types/YieldList";
import { ActionType, getType } from "typesafe-actions";
import * as yieldListActions from "./yieldListActions";

export type YieldListState = {
  [K in yieldListActions.YieldListContentType]?: {
    loading?: boolean;
    data?: YieldList[];
    error?: string;
  };
};

export type YieldListActions = ActionType<typeof yieldListActions>;

export default function yieldList(state: YieldListState = {}, action: YieldListActions) {
  switch (action.type) {
    case getType(yieldListActions.load):
      return { ...state, [action.contentType]: { ...state[action.contentType], loading: true } };
    case getType(yieldListActions.loadSuccess):
      return {
        ...state,
        [action.contentType]: { loading: false, data: action.data, error: undefined },
      };
    case getType(yieldListActions.loadFail):
      return { ...state, [action.contentType]: { loading: false, error: action.error } };
    default:
      return state;
  }
}
